import templateUrl from './pay-stub-tax-deduction.component.html'

export const PayStubTaxDeductionComponent = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        payStubEntry: "<"
    }
}
